/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
});

export const GetClusterLatestContinuousBackup = {
  id: 'cluster-continuous-backup-latest.get',
  tag: 'Cluster',
  summary: 'Get cluster latest continuous backup',
  description: 'Retrieve all cluster latest continuous backups',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/backup/continuous/latest`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            name: z.string(),
            lastModified: z.date(),
            sizeInBytes: z.number(),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
